import {Injectable} from '@angular/core';
import {MessageService} from 'primeng/components/common/messageservice';

@Injectable()
export class ToadMensagemService {

    constructor(private messageService: MessageService) {
    }

    addSuccess(msg: string) {
        this.messageService.add({key: 'chave', severity: 'success', summary: 'Sucesso', detail: msg});
    }

    addSuccessKey(msg: string, key: string) {
        this.messageService.add({key: key, severity: 'success', summary: 'Sucesso', detail: msg});
    }


    addInfo(msg: string) {
        this.messageService.add({key: 'chave', severity: 'info', summary: 'Info', detail: msg});
    }

    addInfoKey(msg: string, key: string) {
        this.messageService.add({key: key, severity: 'info', summary: 'Info', detail: msg});
    }

    addWarn(msg: string) {
        this.messageService.add({key: 'chave', severity: 'warn', summary: 'Atenção', detail: msg});
    }

    addWarnKey(msg: string, key: string) {
        this.messageService.add({key: key, severity: 'warn', summary: 'Atenção', detail: msg});
    }

    addError(msg: string) {
        this.messageService.add({key: 'chave', severity: 'error', summary: 'Erro', detail: msg});
    }

    addErrorKey(msg: string, key: string) {
        this.messageService.add({key: key, severity: 'error', summary: 'Erro', detail: msg});
    }

    // showMultiple() {
    //     this.msgs = [];
    //     this.msgs.push({severity:'info', summary:'Message 1', detail:'PrimeNG rocks'});
    //     this.msgs.push({severity:'info', summary:'Message 2', detail:'PrimeUI rocks'});
    //     this.msgs.push({severity:'info', summary:'Message 3', detail:'PrimeFaces rocks'});
    // }


    clearViaService() {
        this.messageService.clear();
    }

}



// WEBPACK FOOTER //
// ./src/service/toad-mensagem.service.ts